import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWith401Handling } from '../shared/api/baseQueryWith401Handling';
import { AdminProduct, SaveAdminProductsRequest, CreateRegionRequest } from './models/AdminProduct';
import Region from '../shared/models/Region';

export const adminApi = createApi({
    reducerPath: 'adminApi',
    baseQuery: baseQueryWith401Handling,
    tagTypes: ['AdminProducts', 'Regions'],
    endpoints: (builder) => ({
        getRegions: builder.query<Region[], void>({
            query: () => ({ url: 'settings/regions' }),
            providesTags: ['Regions']
        }),
        getAdminProducts: builder.query<AdminProduct[], string>({
            query: (regionId) => ({
                url: `admin/products`,
                params: { regionId }
            }),
            providesTags: ['AdminProducts']
        }),
        saveAdminProducts: builder.mutation<AdminProduct[], SaveAdminProductsRequest>({
            query: (body) => ({
                url: 'admin/products/save',
                method: 'POST',
                body
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                const { data } = await queryFulfilled;
                dispatch(
                    adminApi.util.updateQueryData('getAdminProducts', arg.regionId, () => data)
                );
            }
        }),
        createRegion: builder.mutation<Region, CreateRegionRequest>({
            query: (body) => ({
                url: 'admin/regions/create',
                method: 'POST',
                body
            }),
            invalidatesTags: ['Regions', 'AdminProducts']
        })
    })
});

export const {
    useGetRegionsQuery,
    useGetAdminProductsQuery,
    useLazyGetAdminProductsQuery,
    useSaveAdminProductsMutation,
    useCreateRegionMutation
} = adminApi;
